(function () {
  "use strict";

  var EVENT_NAME = "interest_clicked";
  var config = window.AlilaoGoogleTrackingConfig || {};
  var originalXhrOpen = window.XMLHttpRequest.prototype.open;
  var originalXhrSend = window.XMLHttpRequest.prototype.send;
  var originalFetch = window.fetch;

  function copyObject(source) {
    var copy = {};

    Object.keys(source || {}).forEach(function (key) {
      copy[key] = source[key];
    });

    return copy;
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(?:\.js)?(?:[?#]|$)/i.test(String(url || ""));
  }

  function sendGoogleEvent(eventName, payload) {
    var eventPayload;

    if (typeof window.gtag !== "function") return;

    eventPayload = copyObject(payload);
    if (config.adsId && !eventPayload.send_to) {
      eventPayload.send_to = config.adsId;
    }

    window.gtag("event", eventName, eventPayload);
  }

  function sendGoogleConversion(sendTo, payload) {
    var conversionPayload;

    if (!sendTo || typeof window.gtag !== "function") return;

    conversionPayload = copyObject(payload);
    conversionPayload.send_to = sendTo;
    window.gtag("event", "conversion", conversionPayload);
  }

  function getItemPriceInMajorUnits(item) {
    var price = Number(
      item.final_price !== undefined ? item.final_price : item.price,
    );

    return isNaN(price) ? 0 : price / 100;
  }

  function buildGoogleItem(item) {
    var googleItem = {
      item_id: String(item.variant_id || item.id || item.product_id || ""),
      item_name: item.product_title || item.title || item.name || "",
      item_variant: item.variant_title || item.variant || "",
      item_brand: item.vendor || "",
      price: getItemPriceInMajorUnits(item),
      quantity: Number(item.quantity) || 1,
      google_business_vertical: "retail",
    };

    Object.keys(googleItem).forEach(function (key) {
      if (googleItem[key] === "") {
        delete googleItem[key];
      }
    });

    return googleItem;
  }

  function trackAddedItems(responsePayload) {
    var rawItems;
    var items;
    var value;
    var currency = config.currency || "CRC";

    if (!responsePayload) return;

    rawItems =
      responsePayload.items && responsePayload.items.length
        ? responsePayload.items
        : [responsePayload];
    items = rawItems.map(buildGoogleItem);
    value = items.reduce(function (total, item) {
      return total + (Number(item.price) || 0) * (Number(item.quantity) || 1);
    }, 0);

    sendGoogleEvent("add_to_cart", {
      currency: currency,
      value: value,
      items: items,
    });

    sendGoogleConversion(config.addToCartConversionSendTo, {
      currency: currency,
      value: value,
    });
  }

  function parseAndTrackCartResponse(responseText) {
    var responsePayload;

    try {
      responsePayload = JSON.parse(responseText);
    } catch (error) {
      return;
    }

    trackAddedItems(responsePayload);
  }

  window.XMLHttpRequest.prototype.open = function (method, url) {
    this.__alilaoTracksCartAdd =
      String(method || "").toUpperCase() === "POST" && isCartAddUrl(url);
    return originalXhrOpen.apply(this, arguments);
  };

  window.XMLHttpRequest.prototype.send = function () {
    var request = this;

    if (request.__alilaoTracksCartAdd) {
      request.addEventListener("load", function () {
        if (request.status >= 200 && request.status < 300) {
          parseAndTrackCartResponse(request.responseText);
        }
      });
    }

    return originalXhrSend.apply(request, arguments);
  };

  if (typeof originalFetch === "function") {
    window.fetch = function (resource, options) {
      var requestUrl =
        typeof resource === "string" ? resource : resource && resource.url;
      var requestMethod =
        (options && options.method) ||
        (resource && resource.method) ||
        "GET";
      var shouldTrack =
        String(requestMethod).toUpperCase() === "POST" &&
        isCartAddUrl(requestUrl);

      return originalFetch.apply(this, arguments).then(function (response) {
        if (shouldTrack && response.ok) {
          response
            .clone()
            .json()
            .then(trackAddedItems)
            .catch(function () {});
        }

        return response;
      });
    };
  }

  function getClosestInterestTarget(element) {
    if (!element || !element.closest) return null;
    return element.closest("[data-conversion-interest]");
  }

  function cleanValue(value) {
    return typeof value === "string" && value.length ? value : undefined;
  }

  function buildPayload(target) {
    var payload = {
      type:
        cleanValue(target.getAttribute("data-conversion-type")) || "unknown",
      source: cleanValue(target.getAttribute("data-conversion-source")),
      product_handle: cleanValue(target.getAttribute("data-product-handle")),
      variant_id: cleanValue(target.getAttribute("data-variant-id")),
      page_url: window.location.href,
    };

    Object.keys(payload).forEach(function (key) {
      if (
        payload[key] === undefined ||
        payload[key] === null ||
        payload[key] === ""
      ) {
        delete payload[key];
      }
    });

    return payload;
  }

  function publishInterest(payload) {
    if (
      !window.Shopify ||
      !window.Shopify.analytics ||
      typeof window.Shopify.analytics.publish !== "function"
    ) {
      return;
    }

    window.Shopify.analytics.publish(EVENT_NAME, payload);
  }

  function isWhatsappHref(href) {
    return (
      /(?:^|\/\/)(?:api\.)?whatsapp\.com\//i.test(href) ||
      /(?:^|\/\/)wa\.me\//i.test(href) ||
      /^whatsapp:/i.test(href)
    );
  }

  function getWhatsappTarget(element) {
    var target;
    var href;

    if (!element || !element.closest) return null;

    target = element.closest("a, button, [data-google-whatsapp]");
    if (!target) return null;

    href = target.getAttribute("href") || "";
    if (
      target.hasAttribute("data-google-whatsapp") ||
      isWhatsappHref(href)
    ) {
      return target;
    }

    return null;
  }

  function trackWhatsappClick(target, eventCallback) {
    var payload = buildPayload(target);
    var googlePayload = {
      link_url: target.getAttribute("href") || window.location.href,
      link_text: (target.textContent || "").replace(/\s+/g, " ").trim(),
      source:
        payload.source ||
        (payload.type !== "unknown" ? payload.type : "whatsapp_link"),
      page_location: window.location.href,
    };
    var conversionPayload = {};

    sendGoogleEvent("whatsapp_click", googlePayload);
    if (typeof eventCallback === "function") {
      conversionPayload.event_callback = eventCallback;
    }
    sendGoogleConversion(config.whatsappConversionSendTo, conversionPayload);
  }

  function prepareTrackedNavigation(event, target) {
    var href;
    var hasNavigated = false;
    var navigate;

    if (
      !config.whatsappConversionSendTo ||
      !target ||
      target.tagName !== "A" ||
      target.getAttribute("target") === "_blank" ||
      target.hasAttribute("download") ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return null;
    }

    href = target.href || target.getAttribute("href");
    if (!href) return null;

    event.preventDefault();
    navigate = function () {
      if (hasNavigated) return;
      hasNavigated = true;
      window.location.href = href;
    };

    window.setTimeout(navigate, 1000);
    return navigate;
  }

  document.addEventListener("click", function (event) {
    var target = getClosestInterestTarget(event.target);
    var whatsappTarget = getWhatsappTarget(event.target);
    var navigationCallback;

    if (
      whatsappTarget &&
      whatsappTarget.getAttribute("aria-disabled") !== "true" &&
      !whatsappTarget.disabled
    ) {
      navigationCallback = prepareTrackedNavigation(event, whatsappTarget);
      trackWhatsappClick(whatsappTarget, navigationCallback);
    }

    if (!target) return;
    if (target.getAttribute("aria-disabled") === "true" || target.disabled)
      return;

    publishInterest(buildPayload(target));
  });

  window.AlilaoGoogleTracking = {
    trackAddToCart: trackAddedItems,
    trackWhatsappClick: trackWhatsappClick,
  };
})();
